import { AppAPIService } from "../../../../../services/AppAPIService";

// actions.js
export const handleStatusDocument =
  (documentId, typeDoc, status, observationReject) =>
  async (dispatch, getState) => {
    const api = new AppAPIService();
    try {
      await api.makeHttpRequest({
        method: "PUT",
        url: `/document/update-status/${documentId}`,
        data: {
          typeDoc,
          status,
          observation: observationReject,
        },
      });

      if (status === "REJECTED" && observationReject) {
        dispatch({ type: "REJECT_DOCUMENT_SUCCESS" });
      } else {
        dispatch({ type: "APPROVE_DOCUMENT_SUCCESS" });
      }
    } catch (error) {
      dispatch({ type: "APPROVE_DOCUMENT_FAILURE", error });
    }
  };

// reducer.js
const initialState = {
  documentApproved: false,
  documentRejected: false,
  error: null,
};

export const documentReducer = (state = initialState, action) => {
  switch (action.type) {
    case "APPROVE_DOCUMENT_SUCCESS":
      return { ...state, documentApproved: true, documentRejected: false };
    case "REJECT_DOCUMENT_SUCCESS":
      return { ...state, documentRejected: true, documentApproved: false };
    case "APPROVE_DOCUMENT_FAILURE":
      return { ...state, error: action.error };
    default:
      return state;
  }
};
